import { type DashboardId, type TypePick, type WithOptionalNodes } from '@reconcept-platform/shared/data-access';
import {
  type GoalCardSummaryItemFragment,
  type MostSevereSeverityEnum,
  type Workspace,
} from '@reconcept-platform/shared/types';

export interface WorkspaceMatrixView {
  id?: string;
  title?: string;
  alternativeTitle?: string;
  subDomainId?: string;
  domainId?: string;
  hasFeatured?: boolean;
  severity: MostSevereSeverityEnum;
  text: string;
  isCharacterIcon: boolean;
  showPreview?: boolean;
  onlySeverity?: boolean;
  link: string | (string | number)[];
  queryParams?: Record<string, string>;
  goalCardSummaries?: GoalCardSummaryItemFragment[];
}

export function determineDashboardViewerCanManageWorkspace(
  dashboard: DashboardId & WithOptionalNodes<TypePick<Workspace, 'viewerCanManage'>, 'workspaces'>,
): boolean {
  // @ts-expect-error TS18048 possibly undefined | TS2322 type not assignable
  return dashboard.workspaces ? dashboard.workspaces.nodes.some((workspace) => workspace.viewerCanManage) : undefined;
}

export function determineDashboardViewerCanReadWorkspace(
  dashboard: DashboardId & WithOptionalNodes<TypePick<Workspace, 'viewerCanRead'>, 'workspaces'>,
): boolean {
  // @ts-expect-error TS18048 possibly undefined | TS2322 type not assignable
  return dashboard.workspaces ? dashboard.workspaces.nodes.some((workspace) => workspace.viewerCanRead) : undefined;
}
